import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { NOTIFICATION_ROUTES } from '../constants/routes.constants';
import { appLayoutRoute } from '../../layout';

const notificationListRoute = createRoute({
  path: NOTIFICATION_ROUTES.LIST,
  getParentRoute: () => appLayoutRoute,
  component: lazyRouteComponent(() =>
    import('../pages').then(m => ({ default: m.NotificationListPage }))
  ),
});

const notificationCreateRoute = createRoute({
  path: NOTIFICATION_ROUTES.CREATE,
  getParentRoute: () => appLayoutRoute,
  component: lazyRouteComponent(() =>
    import('../pages').then(m => ({ default: m.NotificationCreatePage }))
  ),
});

const notificationDetailRoute = createRoute({
  path: NOTIFICATION_ROUTES.DETAIL,
  getParentRoute: () => appLayoutRoute,
  component: lazyRouteComponent(() =>
    import('../pages').then(m => ({ default: m.NotificationDetails }))
  ),
});

const notificationRoutes = [
  notificationListRoute,
  notificationCreateRoute,
  notificationDetailRoute,
];

export default notificationRoutes;
